import { ROLLOUT_STATE } from '~common';
import { permissionRolloutConfigService } from '~services/permission-rollout-config.service';
import { canAccessByPermission } from '~utils/can-access-by-permission.util';

const PREFIX = '[permission-audit]';

// Dedupe so a re-rendering component doesn't spam the console with the same
// observation every render.
const loggedChecks = new Set<string>();

export const logPermissionAuditCheck = (
  context: string,
  keys: readonly string[],
  legacyGranted: boolean,
  permissionWouldGrant: boolean,
): void => {
  const dedupeKey = `${context}|${keys.join(
    ',',
  )}|${legacyGranted}|${permissionWouldGrant}`;
  if (loggedChecks.has(dedupeKey)) return;
  loggedChecks.add(dedupeKey);

  const status = legacyGranted === permissionWouldGrant ? 'MATCH' : 'MISMATCH';
  // eslint-disable-next-line no-console
  console.info(
    `${PREFIX} ${status} — ${context} keys=[${keys.join(
      ', ',
    )}] legacy=${legacyGranted} permission=${permissionWouldGrant}`,
  );
};

/**
 * While any of `keys` is in AUDIT state, logs the legacy decision against
 * what `canAccessByPermission` would decide — catches a MISMATCH before the
 * rollout flips to ON. No-op for OFF/ON (shared by `RolesRestrict` and
 * `canAccessCapability`, which each handle those states themselves).
 */
export const auditPermissionCheck = (
  context: string,
  keys: readonly string[],
  legacyGranted: boolean,
): void => {
  const isAudited = keys.some(
    (key) =>
      permissionRolloutConfigService.getPermissionState(key) ===
      ROLLOUT_STATE.AUDIT,
  );
  if (!isAudited) return;

  logPermissionAuditCheck(
    context,
    keys,
    legacyGranted,
    keys.some((key) => canAccessByPermission(key)),
  );
};
